import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { CallingScreenService } from '../_services/calling-screen.service';
import { environment } from 'src/environments/environment';
import { Subject, Observable, interval } from 'rxjs';
import { takeUntil, map, catchError } from 'rxjs/operators';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { GameModeService } from '../game-mode/_services/game-mode.service';
import { AmplitudeService } from 'src/app/_services/amplitude.service';

declare var $: any;

@AutoUnsubscribe
@Component({
  selector: 'app-calling-screen-beta',
  templateUrl: './calling-screen-beta.component.html',
  styleUrls: ['./calling-screen-beta.component.scss']
})
export class CallingScreenBetaComponent implements OnInit, OnDestroy {

  filteredData: any = [];
  currLang;
  loading = true;
  innerWidth;
  innerHeight;
  response: any = [];
  id: number;
  reload: boolean;
  classTotalWidth: number;
  refreshFlag: boolean = true;
  owlContainerWidth: number;
  customOptions: OwlOptions = {};
  studentContainer = true;
  classItem = { name: '', grade: {}, students: [], width: 0, col: 1 };
  soundsArray = [];
  logedInUserType = "";
  isCallingScreenGamification = false;
  tescherClassList: any = [];

  studentsToDeliver: any = [];
  studentsToDeliverIds: any = [];
  deliveryLoadingStates: { [key: string]: boolean } = {};
  baseuUlr = environment.img_url;
  noDeliverFlag: boolean = false;
  originalGrades: Array<any> = [];
  grades: Array<any> = [];
  allClasses: Array<any> = [];
  filteredClasses: Array<any> = [];
  filterArray: Array<any> = [];
  sections: Array<any> = [];
  gradeName = 'all';
  className = 'all';
  sectionName = 'all';
  gradeId: number;
  classId: number;
  sectionId: number;
  direction = 1;
  scrollWidth = 0;
  stopScroll = false;
  isScroll = false;
  wasScroll = false;
  interval;
  delegationInProgressFlag = false;
  userId;
  reqArray = [];
  totalRequests;
  filteredRequests;
  activeTab;
  recallSoundsArray = [];
  isRecall: boolean = false;
  recallCount = 0;
  reasonForNoDeliver;
  toggleRecallTipFlag = false;
  recallTip: string = "";
  realtimeSub$: any
  showVoiceOnAlert: boolean = false;
  private callingScreenBetaVisibilityChangeHandler: () => void;
  constructor(
    private router: Router,
    private callingScreen: CallingScreenService,
    private translate: TranslateService,
    private globalService: GlobalService,
    private ref: ChangeDetectorRef,
    private errorMsgService: ErrorMsgService,
    private dataService: DataService,
    public gameModeService: GameModeService,
    private amplitudeService: AmplitudeService,
  ) {
    this.userId = localStorage.getItem("userId");
    this.callingScreen.getIsReconected().subscribe(res => {
      if (res == true) {
        this.initiatCallingScreen();
        this.callingScreen.setIsReconected(false);
        setInterval(() => {
          this.ref.detectChanges();
        }, 1000)
      }
    })
    let reloadFlag = localStorage.getItem("relaod");
    if (reloadFlag == 'true') {
      localStorage.setItem("relaod", 'false');
      window.location.reload();
    }
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.logedInUserType = localStorage.getItem('loginAs');
  }

  private tryPreselectOnlyClass(): void {
    const assignedClasses = this.allClasses;
    if (Array.isArray(assignedClasses) && assignedClasses.length === 1) {
      const onlyClass = assignedClasses[0];
      // Resolve the corresponding grade from current grades list if possible
      const onlyGrade = (this.grades || []).find(g => g?.id == onlyClass?.grade_id) || onlyClass?.grade || null;

      this.gradeId = onlyGrade ? onlyGrade.id : null;
      this.gradeName = onlyGrade ? onlyGrade : 'all';
      this.classId = onlyClass.id;
      this.className = onlyClass;
      // Keep sections untouched per requirement
      this.filteredClasses = this.gradeId ? this.allClasses.filter(c => c.grade_id == this.gradeId) : [];
      // If this single class's grade belongs to a section, preselect that section too
      const maybeSectionId = onlyGrade && typeof onlyGrade.section_id !== 'undefined' ? onlyGrade.section_id : null;
      if (maybeSectionId) {
        const matchedSection = (this.sections || []).find(sec => sec?.id == maybeSectionId);
        if (matchedSection) {
          this.sectionId = matchedSection.id;
          this.sectionName = matchedSection;
        }
      }
      this.filteringData();
    }
  }

  ngOnInit(): void {
    // Check if this is NOT a beta school and redirect to old calling screen
    this.dataService.getIsCallingScreenBeta().subscribe(isBeta => {
      if (!isBeta) {
        this.router.navigate(['/calling-screen/calling-screen']);
        return;
      }
    });

    this.dataService.getIsCallingScreenGamification().subscribe(res => {
      this.isCallingScreenGamification = res;
    });

    this.activeTab = window.location.pathname.split('/')[2];
    this.dataService.getAllSections().subscribe((res: any) => {
      if (res) {
        this.sections = res;
        // In case classes were already loaded and there is exactly one class, attempt section preselect now
        this.tryPreselectOnlyClass();
      }
    })

    this.callingScreen.subscribe(`calling_screen_${localStorage.getItem('schoolId')}`, `App\\Events\\CallingScreen`, data => {
      console.log('cs data', data);
      // if (this.delegationInProgressFlag == true) {
      //   this.reqArray.push(Object.assign({}, data));
      // } else {
      if (this.activeTab == 'calling-screen-beta') {
        this.recallSoundsArray = [];
        this.requestProssesing(data);
      }
      // }
    })

    ///supervisor sound play
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.getClasses();


    // this.innerWidth = (window.innerWidth - 76);
    // this.innerHeight = window.innerHeight - 116;
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    this.reload = true;
    this.checkVisibilityChange();
    // this.animateRequests();
  }
  requestProssesing(data) {
    let enableVoiceCalling = localStorage.getItem('voiceCalling');
    let statusCalling = localStorage.getItem('statusCalling');
    let studentName = data.students[0].audio_file_path;

    let arabicStatus = data.students[0].request_status.status_file_url.ar;
    let englishStatus = data.students[0].request_status.status_file_url.en;
    let arabicLateStatus = data.students[0].request[0].status_file_url.ar;
    let englishLateStatus = data.students[0].request[0].status_file_url.en;
    let isLate = data.students[0].request[0].is_late;
    let deleted_at = data.students[0]?.request[0]?.deleted_at;
    let isDelivered = data.students[0]?.request_status?.name;

    // Handle terminal statuses EARLY to avoid re-adding removed students
    // - Immediately remove if request was deleted (cancelled)
    // - Show celebration GIF only for 'delivered' or for 'with_parent'
    if (deleted_at != null) {
      this.hideCelebrationGifAndRemoveStudent(data.students[0].id);
      return;
    }
    else if (isDelivered == 'delivered' || isDelivered == 'with_parent') {
      this.showCelebrationGifForStudent(data.students[0].id);
      return;
    }

    let inTeacherClass = false;
    if (this.logedInUserType == "teacher" || this.logedInUserType == "supervisor") {
      let clazz = this.tescherClassList.find(cls => cls.id == data.students[0].class_id);
      if (clazz) {
        inTeacherClass = true;
      }
    } else {
      inTeacherClass = true;
    }
    // Notify game mode of dismissal if game is active
    if (this.gameModeService.isGameActive() && inTeacherClass) {
      this.gameModeService.triggerDismissalInterrupt({
        studentId: data.students[0].id,
        studentName: data.students[0].name || data.students[0].first_name || 'Student',
        studentImage: data.students[0].image_path || null,
        className: '',
        requestId: data.students[0].request?.[0]?.id || 0
      });
    }

    if (inTeacherClass) {
      let Clazz = this.filteredData.find(Clas => Clas.id == data.students[0].class_id);
      if (Clazz != undefined) {
        // findIndex returns the Index of student if exists or -1 if no student was found 
        let existingStudent = Clazz.students.findIndex(student => student.id == data.students[0].id);
        // check if student exists update it in-place instead of removing/adding to maintain position
        if (existingStudent >= 0) {
          Clazz.students[existingStudent] = { ...Clazz.students[existingStudent], ...data.students[0] };
        }
        // if student doesn't exist push directly from pusher data 
        else {
          Clazz.students.push(...data.students);
        }
        
        // Assign GIFs to new students
        this.assignRandomGifsToStudents(data.students);
        // Assign avatars to new students
        this.assignRandomAvatarsToStudents(data.students);
      }
      //  check if the student is not deleted push the class to the filteredData array
      else if (!deleted_at) {
        this.filteredData.push(data);
        // Assign GIFs to new students
        this.assignRandomGifsToStudents(data.students);
        // Assign avatars to new students
        this.assignRandomAvatarsToStudents(data.students);
      }
    }

    if (enableVoiceCalling === 'true') {
      let inTeacherClass = false;
      if (this.logedInUserType == "teacher" || this.logedInUserType == "supervisor") {
        let clazz = this.tescherClassList.find(cls => cls.id == data.students[0].class_id);
        if (clazz) {
          inTeacherClass = true;
        }
      } else {
        inTeacherClass = true;
      }
      // Start with the section_id check
      let isStudentMatchFilter = this.sectionId ? data.section_id == this.sectionId : true;
      // Add the grade_id check
      isStudentMatchFilter = this.gradeId ? data.grade_id == this.gradeId && isStudentMatchFilter : isStudentMatchFilter;
      // Add the class_id check
      isStudentMatchFilter = this.classId ? data.students[0].class_id == this.classId && isStudentMatchFilter : isStudentMatchFilter;
      if (isDelivered != 'delivered' && isDelivered != 'with_parent') {

        if (!deleted_at && inTeacherClass && isStudentMatchFilter && studentName) {
          this.addSoundToPlay(studentName);
          switch (statusCalling) {

            case 'ar':
              if (isLate == 1) {
                this.addSoundToPlay(arabicLateStatus);

              }
              else {
                this.addSoundToPlay(arabicStatus);

              }
              break;
            case 'en':
              if (isLate == 1) {
                this.addSoundToPlay(englishLateStatus);

              }
              else {
                this.addSoundToPlay(englishStatus);

              }
              break;
          }
          if (this.soundsArray.length != 0) {
            this.playSound();


          }
        }
      }

    }
    this.filteringData();
    // this.clearFilter();

    if (this.reqArray.length > 0) {
      this.reqArray.splice(0);
      this.requestProssesing(this.reqArray[0]);
    }

    // this.clearFilter();
  }
  getClasses(reload = false) {
    if (this.logedInUserType == "teacher") {
      this.callingScreen.getTeacherClasses(localStorage.getItem("userId"), localStorage.getItem("lastShcoolSelectedId")).subscribe((classes: any) => {
        this.tescherClassList = classes;
        this.delegationInProgressFlag = false;
        this.allClasses = classes;

        this.grades = classes.filter(e => e.grade).map(e => e.grade);
        this.grades = this.grades.filter(function (elem, index, self) {
          return index === self.findIndex(e => elem.id == e.id);
        });
        this.originalGrades = [];
        this.originalGrades = this.grades;
        this.filterSectionsBasedOnRoleGrades(this.originalGrades, this.sections);
        this.tryPreselectOnlyClass();
        if (this.reload) {
          this.initiatCallingScreen();
        }
        // if (this.reqArray.length != 0) {
        //   this.requestProssesing(this.reqArray[0]);
        //   this.reqArray.splice(0);
        // }
      });
    } else if (this.logedInUserType == "supervisor") {
      this.callingScreen.getSupervisorGrades(localStorage.getItem('userId') , localStorage.getItem("lastShcoolSelectedId")).subscribe((res: any) => {
        // Build flat classes list from grades
        const classes = [] as any[];
        res.forEach(grade => {
          classes.push(...grade.school_classes);
        });
        this.tescherClassList = classes;
        this.delegationInProgressFlag = false;

        // Set grades/originalGrades and aggregate allClasses similar to previous logic
        this.originalGrades = [];
        this.originalGrades = res;
        this.grades = this.originalGrades;
        this.grades.map(grade => {
          this.allClasses.push(...grade.school_classes)
        })
        this.filterSectionsBasedOnRoleGrades(this.originalGrades, this.sections);

        if (this.reload) {
          this.initiatCallingScreen();
        }
        this.tryPreselectOnlyClass();
      });
    } else {
      this.dataService.getAllGrades().subscribe((res: any) => {
        this.originalGrades = res;
        this.grades = this.originalGrades;
        this.grades.map(grade => {
          this.allClasses.push(...grade.school_classes)
        })
        // this.filteredClasses = this.allClasses;
        this.initiatCallingScreen();
        this.tryPreselectOnlyClass();
      })
    }
  }

  initiatCallingScreen() {
    this.callingScreen.showCallingScreen(localStorage.getItem('schoolId')).subscribe((data: any) => {
      // console.log('cs api data', data);
      this.refreshFlag = false;
      this.response = [];
      this.loading = false;
      this.filteredData = data.filter(Class => {
        return Class.students.length > 0;
      })
      
      // Assign random GIFs to all students
      this.filteredData.forEach(cls => {
        this.assignRandomGifsToStudents(cls.students);
        this.assignRandomAvatarsToStudents(cls.students);
      });
      
      this.filteringData();
      // this.clearFilter();
      this.toggleAnimationWithFilter(false)
      this.refreshFlag = true;
      if (this.soundsArray.length != 0) {
        this.playSound();
      }
    })
  }
  // this method to change every class colums and width debending on number of students in each class
  // callingScreenLayout(Class) {
  //   let csl=Class.students.length;
  //   let percent;
  //   switch (true) {
  //       case csl > 4 && csl <= 8:
  //         this.classItem.col = 6;
  //         percent= 20/ 100;
  //       break;
  //       case csl > 8 && csl <= 12:
  //         this.classItem.col = 4;
  //         percent= 30/ 100;
  //       break;
  //       case csl > 12 && csl <= 16:
  //         this.classItem.col = 3;
  //         percent= 35/ 100;
  //       break;
  //       case csl > 16 && csl <= 24:
  //         this.classItem.col = 2;
  //         percent= 45/ 100;
  //       break;
  //       case csl > 24:
  //         this.classItem.col = 1;
  //         percent= 100/ 100;
  //       break;

  //     default:
  //       this.classItem.col = 12;
  //       percent= 12/ 100;
  //   }
  //   this.classItem.width = this.innerWidth * percent;
  // }
  callingScreenLayout(Class) {
    let csl = Class.students.length;
    let percent;
    
    // Simplified layout logic for better grid display
    switch (true) {
      case this.innerWidth <= 480:
        // Mobile devices - single column
        this.classItem.col = 12;
        percent = 100 / 100;
        break;
        
      case this.innerWidth <= 768:
        // Small tablets - 2-3 columns
        if (csl <= 6) {
          this.classItem.col = 6;
          percent = 50 / 100;
        } else if (csl <= 12) {
          this.classItem.col = 4;
          percent = 33.33 / 100;
        } else {
          this.classItem.col = 3;
          percent = 25 / 100;
        }
        break;
        
      case this.innerWidth <= 1024:
        // Medium tablets - 3-4 columns
        if (csl <= 8) {
          this.classItem.col = 4;
          percent = 25 / 100;
        } else if (csl <= 16) {
          this.classItem.col = 3;
          percent = 33.33 / 100;
        } else {
          this.classItem.col = 2;
          percent = 50 / 100;
        }
        break;
        
      case this.innerWidth <= 1200:
        // Small desktops - 4-5 columns
        if (csl <= 10) {
          this.classItem.col = 3;
          percent = 25 / 100;
        } else if (csl <= 20) {
          this.classItem.col = 2;
          percent = 50 / 100;
        } else {
          this.classItem.col = 1;
          percent = 100 / 100;
        }
        break;
        
      default:
        // Large desktops - 5-6 columns
        if (csl <= 12) {
          this.classItem.col = 2;
          percent = 20 / 100;
        } else if (csl <= 24) {
          this.classItem.col = 2;
          percent = 20 / 100;
        } else {
          this.classItem.col = 1;
          percent = 100 / 100;
        }
        break;
    }
    
    // Set the width based on the calculated percentage
    this.classItem.width = this.innerWidth * percent;
    
    // Ensure minimum card width for better readability
    const minCardWidth = 200;
    if (this.classItem.width < minCardWidth) {
      this.classItem.width = minCardWidth;
    }
  }


  filteringData() {
    if (this.gradeId || this.sectionId) {
      this.scrollWidth = 0;
      this.direction = 1; // Reset direction to start from left
      clearInterval(this.interval);
      this.toggleAnimationWithFilter(false);
    }
    this.response = [];
      // console.log('filteredData', this.filteredData);
      // console.log('sectionId', this.sectionId);
    // Start with the base data
    let baseArray = this.filteredData;
    // Apply section_id filter if sectionId is defined
    if (this.sectionId) {
      baseArray = baseArray.filter(request => request.section_id == this.sectionId);
      // console.log('After section_id filter:', baseArray);
    }
    // Apply grade_id filter if gradeId is defined
    if (this.gradeId) {
      baseArray = baseArray.filter(request => request.grade_id == this.gradeId);
      // console.log('After grade_id filter:', baseArray);
    }
    // Apply class_id filter if classId is defined
    if (this.classId) {
      baseArray = baseArray.filter(request => request.id == this.classId);
      // console.log('After class_id filter:', baseArray);
    }
    // Assign the final filtered array to this.filterArray
    this.filterArray = baseArray;
    // console.log('Final filtered array:', this.filterArray);
    this.getFilteredData(this.filterArray);
    // this.filterArray.length > 0 ? this.getFilteredData(this.filterArray):this.getFilteredData(this.filteredData)
  }

  getFilteredData(array: Array<any>) {
    this.totalRequests = 0;
    this.filteredRequests = 0;
    array.forEach(Class => {
      this.classItem.grade = Class.grade;
      this.classItem.name = Class.name;
      this.classItem.students = Class.students;
      
      // Ensure all students have GIFs assigned
      this.assignRandomGifsToStudents(this.classItem.students);
      // Ensure all students have avatars assigned
      this.assignRandomAvatarsToStudents(this.classItem.students);
      
      this.callingScreenLayout(Class);
      this.response.push(this.classItem);
      // this.getOwlContainerWidth();
      this.getClassTotalWidth();
      // this.initializeCustomeOptions();
      this.classItem = { name: '', grade: {}, students: [], width: 0, col: 1 };
      // this.totalRequests += Class.students.length;      
    })
    // get total students in old filteredData array => total requests
    this.filteredData.length > 0 ? this.filteredData.forEach(clazz => {
      this.totalRequests += clazz.students.length;
    }) : '';

    /* get total students in filtered array => filtered requests
    and if the filteredData length equals filterArray length that means
    no filter is applied so the filteredRequest should be Zero.
     */
    this.filterArray.length == this.filteredData.length ? this.filteredRequests = 0 :
      this.filterArray.length > 0 ? this.filterArray.forEach(clazz => {
        this.filteredRequests += clazz.students.length;
      }) : '';
  }

  /* this method is to check if the width of all classes combined is bigger than the owl container width or not,
    then toggle owl custom option based on this condition */
  initializeCustomeOptions() {
    if (this.classTotalWidth > this.owlContainerWidth) {
      this.customOptions = {
        loop: true,
        // rewind: true,
        // items:2,   
        // mouseDrag: true,
        // touchDrag: true,
        // pullDrag: true,
        autoWidth: true,
        navSpeed: 700,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        autoplaySpeed: 1500,
        animateIn: true,
        animateOut: true,
        dots: true,
        dotsSpeed: 700,
        slideBy: 'page',
        slideTransition: 'ease-out',

      };

    }
    else {
      this.customOptions = {
        loop: false,
        dots: false,
        // rewind: true,
        autoWidth: true,
      };
    }
  }

  // to get the total width of the owl container div that carries all  cards of classes 
  getOwlContainerWidth() {
    this.owlContainerWidth = $('owl-carousel-o div').width();
  }

  // to get the total width of all cards of classes 
  getClassTotalWidth() {
    // temp is just a temporary container for each class width
    let temp = 0;
    this.response.forEach(clazz => {
      temp += clazz.width;
    });
    this.classTotalWidth = temp;
  }

  onMascotClicked(): void {
    this.amplitudeService.trackEvent('gameWorld-launch', {});
    this.gameModeService.setAvailableClasses(this.allClasses || []);
    this.gameModeService.quickStart(this.classId);
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnDestroy() {
    this.reload = false;
    this.activeTab = '';
    this.soundsArray = [];
    this.stopAutoScroll(); // Use the new stop method
    this.callingScreen.cleanup();
    this.gameModeService.destroy();
    // remove the event listener refrence when component is destroyed to avoid repeated fires of the event
    document.removeEventListener("visibilitychange", this.callingScreenBetaVisibilityChangeHandler);
    // this.realtimeSub$.unsubscribe();
  }

  setStatus(student) {
    // tslint:disable-next-line:no-non-null-assertion
    /* this condition to handle deifferent responces, in some cases students status can be found directly
     in property request_status , and in the other request_status can't be found and student status can 
     be found in requests array (backend problem)
    */
    if (student.request_status) {
      let stat = null;
      stat = student.request_status.name;
      return stat;
    }
    else {
      let stat = null;
      stat = student.requests[0].status[0].name;
      return stat;
    }
  }


  setIsLateClass(student) {
   //this condition to handle the same backend problem as in setStatus method
    if (student.request) {
      let stat = student.request[0].is_late === 1 ? 'late' : null
      return stat;
    }
    else {
      let stat = student.requests[0].is_late === 1 ? 'late' : null
      // let stat = student.requests[0].pivot.is_late === 1 ? 'late' : null
      return stat;
    }
  }


  closeModal() {
    this.showVoiceOnAlert = false;
  }


  addSoundToPlay(sound) {
    this.soundsArray.push(sound);  
  }
  playingFlag = false;
  playingStatusFlag = false;
  playSound(path = this.soundsArray[0],) {
    // to stop sounds from getting called outside of calling screen 
    if (this.activeTab == 'calling-screen-beta') {
      var audio = new Audio();
      audio.src = path;
      audio.load();
      audio.addEventListener("ended", (currentTime) => {
        this.playingFlag = false;
        if (this.soundsArray.length != 0) {
          this.playSound();
        }
      });
      if (this.playingFlag == false) {

        audio.play().catch(err => {

          this.playingFlag = false;
          this.soundsArray.splice(0, 1);
          if (this.soundsArray.length == 0) {
            setTimeout(() => {
              this.isRecall = false;
            }, 1000);
          }
          if (this.soundsArray.length != 0) {
            this.playSound();
          }
        });
        this.soundsArray.splice(0, 1);
        if (this.soundsArray.length == 0) {
          setTimeout(() => {
            this.isRecall = false;
          }, 1000);
        }
        this.playingFlag = true;
      }
    }
  }

  deliverStudentsDirectly(event) {
    // Set loading state for this request
    this.deliveryLoadingStates[event] = true;
    
    // First get the request by id (previously opendDeliverModal logic)
    this.callingScreen.getRequestById(event, this.logedInUserType).subscribe(res => {
      this.studentsToDeliver = res['students'];
      
      // If successful, immediately proceed to deliver (previously deliverStudents logic)
      this.studentsToDeliverIds = this.studentsToDeliver.map(student => {
        return student.id
      })
      let body = {
        student_id: this.studentsToDeliverIds
      }
      
      switch (this.logedInUserType) {
        case "teacher":
          this.callingScreen.teacherDeliver(body).subscribe(res => {
            // Handle success if needed
          }, err => {
            this.errorMsgService.setMessage(err.error.message);
          }, () => {
            // Delivery completed - clear loading state
            this.deliveryLoadingStates[event] = false;
          });
          break;
        case 'supervisor':
          this.callingScreen.supervisorDeliver(body).subscribe(res => {
            // Handle success if needed
          }, err => {
            this.errorMsgService.setMessage(err.error.message);
          }, () => {
            // Delivery completed - clear loading state
            this.deliveryLoadingStates[event] = false;
          });
          break;
        default:
          // No delivery action for other user types - clear loading state
          this.deliveryLoadingStates[event] = false;
          break;
      }
    }, (err) => {
      // Clear loading state on error
      this.deliveryLoadingStates[event] = false;
      
      if (err) {
        if (err?.error?.message == 'incorrect id') {
          window.location.reload();
        }
        else {
          this.noDeliver(true)
        }
      }
    })
  }

  isStudentDelivering(classIndex: number, studentIndex: number): boolean {
    // Get the request ID for this student
    const student = this.response[classIndex]?.students[studentIndex];
    if (!student) return false;
    
    let requestId: number | null = null;
    if (student.requests && student.requests.length > 0) {
      requestId = student.requests[0].id;
    } else if (student.request && student.request.length > 0) {
      requestId = student.request[0].id;
    }
    
    return requestId ? (this.deliveryLoadingStates[requestId] || false) : false;
  }

  noDeliver(event) {
    if (event == true) {
      this.noDeliverFlag = true

      setTimeout(() => {
        this.noDeliverFlag = false
      }, 3000);
    }
  }

  noDeliverReason(event) {
    switch (event) {
      case 'Admin':
        this.reasonForNoDeliver = this.currLang == 'en' ? 'Admin Does not have access to deliver student' : 'عذراً! لا يمكن للادمن تسليم الطلاب'
        break;
      case 'pending':
        this.reasonForNoDeliver = this.currLang == 'en' ? 'You are unable to make the student delivery because the request is still pending.' : 'لا يمكنك تسليم هذا الطالب الآن , طلب النداء لا يزال قيد الانتظار'
        break;
      case 'parent':
        this.reasonForNoDeliver = this.currLang == 'en' ? 'You are unable to deliver the student because the student has already been delivered, we are currently awaiting parent confirmation.' : 'لا يمكن تسليم هذا الطالب الآن ,الطالب تم تسليمة وفى انتظار تأكيد ولى الأمر'

        break;
      case 'nopermission':
        this.reasonForNoDeliver = this.currLang == 'en' ? 'you are unable to deliver the student because the request has not reached the queue yet.' : 'يبدو أنك غير قادر على تسليم الطالب لأن الطلب لم يصل إلى قائمة الانتظارالخاصة بك  بعد'
        break;
      case 'observer_mode':
        this.reasonForNoDeliver = this.currLang == 'en' ? 'Observers are not permitted to deliver students' : 'عذراً! لا يمكن للملاحظين تسليم الطلاب'
        break;

      default:
        this.reasonForNoDeliver = this.currLang == 'en' ? "This student can't be delivered" : 'لا يمكن تسليم هذا الطالب'
        break;
    }
  }



  setGrade(event) {
    // console.log('gradeEvent', event);
    this.classId = null;
    this.filteredClasses = [];
    this.className = 'all';
    if (event.value == 'all') {
      this.gradeId = null;
    }
    else {
      this.gradeId = event.value.id;
      this.filteredClasses = this.allClasses.filter(clazz => clazz.grade_id == this.gradeId);
    }
    // Auto-select class if only one exists for the selected grade
    if (this.filteredClasses && this.filteredClasses.length === 1) {
      this.className = this.filteredClasses[0];
      this.classId = this.filteredClasses[0].id;
    } else {
    this.className = 'all';
    this.classId = null;
    }
    if (event?.value?.section_id) {
      this.sectionId = event.value.section_id;
      // console.log('sections', this.sections);
      let selectedGradeSection = this.sections.find(section => section.id == this.sectionId);
      // console.log('selectedGradeSection', selectedGradeSection);
      if (selectedGradeSection) {
        this.sectionName = selectedGradeSection;
      }
    }
    else {
      this.sectionName = 'all';
      this.sectionId = null;
    }
    this.filteringData();
  }
  setClass(event) {
    this.classId = event.value.id;
    this.filteringData();
  }

  compareById = (option: any, value: any) => {
    if (option === value) {
      return true;
    }
    if (!option || !value) {
      return false;
    }
    // Handle case where one is 'all' string and other is object
    if (option === 'all' || value === 'all') {
      return option === value;
    }
    // Handle case where both are objects
    return option?.id === value?.id;
  }

  setSection(event) {
    // console.log('sectionEvent', event);
    this.classId = null;
    this.gradeId = null;
    this.gradeName = 'all';
    this.className = 'all';
    this.filteredClasses = [];
    if (event.value == 'all') {
      this.sectionId = null;
      this.sectionName = 'all';
      this.grades = this.originalGrades;
    }
    else {
      this.grades = [];
      this.sectionId = event.value.id;
      this.sectionName = event.value;
      // Include grades that belong to the selected section OR have no section assigned
      this.grades = this.originalGrades.filter(grade => grade.section_id == this.sectionId || grade.section_id == null);
      this.gradeName = 'all';
      this.gradeId = null;
      this.filteredClasses = [];
      this.className = 'all';
      this.classId = null;
    }
    // Auto-select grade if only one exists in this section
    // Note: we now preselect based on grades actually inside the section (gradesInSection),
    // not the full grades list which may include null-section grades.
    this.filteringData();
  }
  clearFilter() {
    this.gradeId = null;
    this.classId = null;
    this.sectionId = null;
    this.gradeName = 'all';
    this.className = 'all';
    this.sectionName = 'all';
    this.filterArray = this.filteredData;
    this.filteredClasses = [];
    this.grades = this.originalGrades;
    this.filteringData();
    if (this.wasScroll) {
      this.toggleAnimationWithFilter(true);
    }
  }

  toggleScroll() {
    this.stopScroll = !this.stopScroll
  }

  initializeAutoScroll() {
    // Get current scroll position from the container
    var container = $('.requests-container');
    if (container.length > 0) {
      this.scrollWidth = container.scrollLeft() || 0;
      // If at the beginning, start scrolling right; if at the end, start scrolling left
      var containerWidth = container.width();
      var scrollableWidth = container[0].scrollWidth;
      var maxScrollLeft = Math.max(0, scrollableWidth - containerWidth);
      
      // If content fits within container, no need to scroll
      if (maxScrollLeft <= 0) {
        this.direction = 1;
        return;
      }
      
      if (this.scrollWidth <= 5) { // Small tolerance for boundary detection
        this.direction = 1; // Start scrolling right
      } else if (this.scrollWidth >= maxScrollLeft - 5) {
        this.direction = -1; // Start scrolling left
      }
      // If in the middle, keep current direction or default to right
      if (this.direction === 0) {
        this.direction = 1;
      }
    }
  }

  switchScroll() {
    this.isScroll = !this.isScroll;
    this.wasScroll = this.isScroll;
    this.toggleAnimationBtn();
    if (this.isScroll) {
      // Initialize scroll position and direction when starting
      this.initializeAutoScroll();
      this.animateRequests();
    }
    else {
      // Stop the animation and update scrollWidth to current position
      this.stopAutoScroll();
    }
  }

  stopAutoScroll() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    
    // Update scrollWidth to the current actual scroll position
    var container = $('.requests-container');
    if (container.length > 0) {
      this.scrollWidth = container.scrollLeft() || 0;
    }
    
    // Stop any ongoing animation
    container.stop(true, false);
  }

  animateRequests() {
    let time = 3000;
    this.interval = setInterval(() => {
      // to fix browser interval cash when the tab is not focused 
      if (document.hasFocus()) {
        var container = $('.requests-container');
        
        // Check if container exists
        if (container.length === 0) {
          return;
        }
        
        var containerWidth = container.width();
        var scrollableWidth = container[0].scrollWidth;
        var maxScrollLeft = Math.max(0, scrollableWidth - containerWidth);
        
        // If content fits within container, no need to scroll
        if (maxScrollLeft <= 0) {
          return;
        }
        
        // Calculate next scroll position with dynamic step size
        var scrollStep = Math.max(150, Math.min(250, maxScrollLeft / 8)); // Adaptive step size
        var nextScrollPosition = this.scrollWidth + (scrollStep * this.direction);
        
        // Check boundaries and change direction
        if (nextScrollPosition >= maxScrollLeft) {
          nextScrollPosition = maxScrollLeft;
          this.direction = -1; // Change to scroll left
        } else if (nextScrollPosition <= 0) {
          nextScrollPosition = 0;
          this.direction = 1; // Change to scroll right
        }
        
        this.scrollWidth = nextScrollPosition;
        
        container.animate({ scrollLeft: `${this.scrollWidth}` },
          {
            duration: time,
            easing: 'swing',
            complete: function () {
              // Animation complete
            }
          });
      }
    }, time);
  }

  toggleAnimationBtn() {
    let button = document.querySelector('.toggle-scroll');
    let onOffIcon = document.querySelector('.on-off');
    this.isScroll ? button.classList.add('outline-off') : button.classList.remove('outline-off');
    this.isScroll ? onOffIcon.classList.add('green') : onOffIcon.classList.remove('green');
  }

  toggleAnimationWithFilter(flag: boolean) {
    // wasScroll to toggle scroll with filter and the initial state of the scroll 
    this.isScroll = flag ? this.wasScroll : flag;
    this.toggleAnimationBtn();
    if (flag && this.wasScroll) {
      this.initializeAutoScroll();
      this.animateRequests();
    }
    else {
      this.stopAutoScroll();
    }
  }
  recallSounds() {
    this.recallSoundsArray = [];
    if (this.soundsArray.length == 0 && this.response.length > 0) {
      this.isRecall = !this.isRecall;
      let statusCalling = localStorage.getItem('statusCalling');
      this.response.forEach(clazz => {
        clazz.students.forEach(student => {
          this.recallSoundsArray.push(student.audio_file_path);
          this.recallSoundsArray.push(student.request ? student.request[0].is_late ? student.request[0].status_file_url[`${statusCalling}`] : student.request_status.status_file_url[`${statusCalling}`] :
            student.requests[0].is_late ? student.requests[0].status_file_url[`${statusCalling}`] : student.request_status.status_file_url[`${statusCalling}`]);
        });
      })
      this.recallCount = this.recallSoundsArray.length;
      this.soundsArray = [...this.soundsArray, ...this.recallSoundsArray]
      this.playSound();
    }
  }

  toggleRecallTip() {
    if (this.response?.length == 0) {
      this.toggleRecallTipFlag = true;
      this.recallTip = 'calling-screen.recall-tip-no-requests';
    }
    if (this.soundsArray?.length > 0) {
      this.toggleRecallTipFlag = true;
      this.recallTip = 'calling-screen.recall-tip-sounds-on';
    }
  }

  filterSectionsBasedOnRoleGrades(grades, sections) {
    // Step 1: Extract section_ids from grades array, filtering out null values
    const sectionIds = new Set(grades
      .map(grade => grade.section_id)
      .filter(id => id !== null)
    );

    // Step 2: Filter sections array
    const filteredSections = sections.length > 0
      ? sections.filter(section => sectionIds.has(section.id))
      : [];

    // Assign filteredSections to this.sections
    this.sections = filteredSections;
  }

  /**
 * Monitors when the browser tab becomes hidden or visible.
 *
 * Behavior:
 * - When the tab is hidden, it disables voice alerts (`showVoiceOnAlert = false`).
 * - When the tab becomes visible again, it checks if voice calling is enabled in localStorage.
 *   If enabled (`localStorage.getItem('voiceCalling') === 'true'`), it re-enables voice alerts.
 *
 * This ensures voice alerts are only active when the tab is in focus and voice calling is turned on.
 */
  checkVisibilityChange(): void {
    if (document.hidden) {
      this.callingScreen.setIsReconected(true);
    }
  }

  getCurrentGradeDisplay(): string {
    if (this.response.length === 0) return '';
    
    // Get the first class to display grade info
    const firstClass = this.response[0];
    if (firstClass && firstClass.grade && firstClass.name) {
      return `${firstClass.grade.name} - ${firstClass.name}`;
    }
    
    return '';
  }

  // New method to assign random GIFs to students
  private assignRandomGifsToStudents(students: any[]) {
    const gifUrls = [
      'assets/cs-beta-gifs/1.gif', 'assets/cs-beta-gifs/2.gif', 'assets/cs-beta-gifs/3.gif',
      'assets/cs-beta-gifs/4.gif', 'assets/cs-beta-gifs/5.gif', 'assets/cs-beta-gifs/6.gif',
      'assets/cs-beta-gifs/7.gif', 'assets/cs-beta-gifs/8.gif', 'assets/cs-beta-gifs/9.gif',
      'assets/cs-beta-gifs/10.gif', 'assets/cs-beta-gifs/11.gif', 'assets/cs-beta-gifs/12.gif',
      'assets/cs-beta-gifs/13.gif', 'assets/cs-beta-gifs/14.gif', 'assets/cs-beta-gifs/15.gif',
      'assets/cs-beta-gifs/16.gif', 'assets/cs-beta-gifs/17.gif', 'assets/cs-beta-gifs/18.gif',
      'assets/cs-beta-gifs/19.gif', 'assets/cs-beta-gifs/20.gif', 'assets/cs-beta-gifs/21.gif',
      'assets/cs-beta-gifs/22.gif', 'assets/cs-beta-gifs/23.gif', 'assets/cs-beta-gifs/24.gif',
      'assets/cs-beta-gifs/25.gif', 'assets/cs-beta-gifs/26.gif', 'assets/cs-beta-gifs/27.gif',
      'assets/cs-beta-gifs/28.gif', 'assets/cs-beta-gifs/29.gif', 'assets/cs-beta-gifs/30.gif',
      'assets/cs-beta-gifs/31.gif', 'assets/cs-beta-gifs/32.gif', 'assets/cs-beta-gifs/33.gif',
      'assets/cs-beta-gifs/34.gif', 'assets/cs-beta-gifs/35.gif', 'assets/cs-beta-gifs/36.gif',
      'assets/cs-beta-gifs/37.gif', 'assets/cs-beta-gifs/38.gif', 'assets/cs-beta-gifs/39.gif',
      'assets/cs-beta-gifs/40.gif', 'assets/cs-beta-gifs/41.gif', 'assets/cs-beta-gifs/42.gif',
      'assets/cs-beta-gifs/43.gif', 'assets/cs-beta-gifs/44.gif', 'assets/cs-beta-gifs/45.gif',
      'assets/cs-beta-gifs/46.gif', 'assets/cs-beta-gifs/47.gif', 'assets/cs-beta-gifs/48.gif',
      'assets/cs-beta-gifs/49.gif', 'assets/cs-beta-gifs/50.gif', 'assets/cs-beta-gifs/51.gif',
      'assets/cs-beta-gifs/52.gif', 'assets/cs-beta-gifs/53.gif', 'assets/cs-beta-gifs/54.gif',
      'assets/cs-beta-gifs/55.gif', 'assets/cs-beta-gifs/56.gif', 'assets/cs-beta-gifs/57.gif',
      'assets/cs-beta-gifs/58.gif', 'assets/cs-beta-gifs/59.gif', 'assets/cs-beta-gifs/60.gif',
      'assets/cs-beta-gifs/61.gif', 'assets/cs-beta-gifs/62.gif', 'assets/cs-beta-gifs/63.gif',
      'assets/cs-beta-gifs/64.gif', 'assets/cs-beta-gifs/65.gif', 'assets/cs-beta-gifs/66.gif',
      'assets/cs-beta-gifs/67.gif', 'assets/cs-beta-gifs/68.gif', 'assets/cs-beta-gifs/69.gif',
      'assets/cs-beta-gifs/70.gif', 'assets/cs-beta-gifs/71.gif', 'assets/cs-beta-gifs/72.gif',
      'assets/cs-beta-gifs/73.gif', 'assets/cs-beta-gifs/74.gif', 'assets/cs-beta-gifs/75.gif',
      'assets/cs-beta-gifs/76.gif', 'assets/cs-beta-gifs/77.gif', 'assets/cs-beta-gifs/78.gif',
      'assets/cs-beta-gifs/79.gif', 'assets/cs-beta-gifs/80.gif', 'assets/cs-beta-gifs/81.gif',
      'assets/cs-beta-gifs/82.gif', 'assets/cs-beta-gifs/83.gif', 'assets/cs-beta-gifs/84.gif',
      'assets/cs-beta-gifs/85.gif', 'assets/cs-beta-gifs/86.gif', 'assets/cs-beta-gifs/87.gif',
      'assets/cs-beta-gifs/88.gif', 'assets/cs-beta-gifs/89.gif', 'assets/cs-beta-gifs/90.gif',
      'assets/cs-beta-gifs/91.gif', 'assets/cs-beta-gifs/92.gif', 'assets/cs-beta-gifs/93.gif',
      'assets/cs-beta-gifs/94.gif', 'assets/cs-beta-gifs/95.gif'
    ];
    
    let assignedCount = 0;
    students.forEach(student => {
      if (!student.celebrationGifUrl) {
        const randomIndex = Math.floor(Math.random() * gifUrls.length);
        student.celebrationGifUrl = gifUrls[randomIndex];
        student.isShowingGif = false; // Initialize the flag
        assignedCount++;
      }
    });
    
    if (assignedCount > 0) {
      // console.log(`🎁 Assigned GIFs to ${assignedCount} students`);
    }
  }

  // Method to assign random avatars to students
  private assignRandomAvatarsToStudents(students: any[]) {
    const avatarUrls = [
      'assets/cs-beta-avatars/1.svg'
      // More avatars will be added later as mentioned
    ];
    
    let assignedCount = 0;
    students.forEach(student => {
      if (!student.avatarUrl) {
        const randomIndex = Math.floor(Math.random() * avatarUrls.length);
        student.avatarUrl = avatarUrls[randomIndex];
        assignedCount++;
      }
    });
    
    if (assignedCount > 0) {
      // console.log(`🎭 Assigned avatars to ${assignedCount} students`);
    }
  }

  // Method to show celebration GIF for a specific student
  private showCelebrationGifForStudent(studentId: number) {
    // Find the student in filteredData
    for (let classIndex = 0; classIndex < this.filteredData.length; classIndex++) {
      const classData = this.filteredData[classIndex];
      const studentIndex = classData.students.findIndex(s => s.id === studentId);
      if (studentIndex !== -1) {
        // Add a small delay before showing the GIF for a smoother transition
        setTimeout(() => {
          classData.students[studentIndex].isShowingGif = true;
          // console.log('🎉 Showing celebration GIF for student:', studentId);
          this.ref.detectChanges(); // Trigger change detection to update the view
          
          // Hide the GIF after 30 seconds and optionally remove the student
          setTimeout(() => {
            this.hideCelebrationGifAndRemoveStudent(studentId);
          }, 3000); // 30 seconds instead of 3 seconds
        }, 300); // Small delay for smooth transition
        
        break;
      }
    }
    
    // Also update filterArray if it exists
    if (this.filterArray && this.filterArray.length > 0) {
      for (let classIndex = 0; classIndex < this.filterArray.length; classIndex++) {
        const classData = this.filterArray[classIndex];
        const studentIndex = classData.students.findIndex(s => s.id === studentId);
        if (studentIndex !== -1) {
          // Don't set isShowingGif here, let the main logic handle it
          break;
        }
      }
    }
  }

  // Method to clear GIF flag for a student in all data structures (optimized)
  private clearGifFlagForStudent(studentId: number) {
    let foundInResponse = false;
    
    // Start with response array (most critical for UI) - early exit optimization
    for (let classIndex = 0; classIndex < this.response.length; classIndex++) {
      const classData = this.response[classIndex];
      const studentIndex = classData.students.findIndex(s => s.id === studentId);
      if (studentIndex !== -1) {
        classData.students[studentIndex].isShowingGif = false;
        foundInResponse = true;
        // Trigger change detection immediately for UI responsiveness
        this.ref.detectChanges();
        break;
      }
    }
    
    // Only clear other arrays if we found the student (performance optimization)
    if (foundInResponse) {
      // Clear in filteredData
      for (let classIndex = 0; classIndex < this.filteredData.length; classIndex++) {
        const classData = this.filteredData[classIndex];
        const studentIndex = classData.students.findIndex(s => s.id === studentId);
        if (studentIndex !== -1) {
          classData.students[studentIndex].isShowingGif = false;
          break;
        }
      }
      
      // Clear in filterArray if it exists and is different from filteredData
      if (this.filterArray && this.filterArray.length > 0 && this.filterArray !== this.filteredData) {
        for (let classIndex = 0; classIndex < this.filterArray.length; classIndex++) {
          const classData = this.filterArray[classIndex];
          const studentIndex = classData.students.findIndex(s => s.id === studentId);
          if (studentIndex !== -1) {
            classData.students[studentIndex].isShowingGif = false;
            break;
          }
        }
      }
      
      // console.log('🔄 Cleared GIF flag for student:', studentId);
    }
  }

  // Method to hide the celebration GIF and remove the student
  private hideCelebrationGifAndRemoveStudent(studentId: number) {
    // console.log('⏰ Hiding celebration GIF and removing student:', studentId);
    
    // First, ensure the GIF flag is cleared in all data structures
    this.clearGifFlagForStudent(studentId);
    
    // Remove from filteredData
    for (let classIndex = 0; classIndex < this.filteredData.length; classIndex++) {
      const classData = this.filteredData[classIndex];
      const studentIndex = classData.students.findIndex(s => s.id === studentId);
      if (studentIndex !== -1) {
        classData.students.splice(studentIndex, 1);
        break;
      }
    }
    
    // Remove from filterArray if it exists
    if (this.filterArray && this.filterArray.length > 0) {
      for (let classIndex = 0; classIndex < this.filterArray.length; classIndex++) {
        const classData = this.filterArray[classIndex];
        const studentIndex = classData.students.findIndex(s => s.id === studentId);
        if (studentIndex !== -1) {
          classData.students.splice(studentIndex, 1);
          break;
        }
      }
    }
    
    // Remove empty classes
    this.filteredData = this.filteredData.filter(cls => cls.students.length > 0);
    if (this.filterArray) {
      this.filterArray = this.filterArray.filter(cls => cls.students.length > 0);
    }
    
    // Refresh the display
    this.filteringData();
  }
}
